import { useAccount } from 'dashboard/composables/useAccount';
import { useAdmin } from 'dashboard/composables/useAdmin';
import {
  itemOcultoNoPainel,
  secaoOcultaNoPainel,
} from 'dashboard/helper/painelDaConversa';

// O que a conta escondeu da aba direita para o papel de quem está logado.
export function usePainelDaConversa() {
  const { currentAccount } = useAccount();
  const { isAdmin } = useAdmin();
  const configuracao = () => currentAccount.value?.settings?.conversation_panel;

  const oculto = chave =>
    itemOcultoNoPainel(configuracao(), isAdmin.value, chave);
  const secaoOculta = nome =>
    secaoOcultaNoPainel(configuracao(), isAdmin.value, nome);

  return { oculto, secaoOculta };
}
